// XLBadge - Sprint 44 XL.
// Etiqueta compacta con variantes semanticas: neutral | info | success
// | warning | danger. Usa tokens via CSS vars. Soporta icono (dot) opcional.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../design/motion';

const CSS_ID = 'xl-badge-css';
const CSS = `
.xl-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: var(--xl-radius-full);
  font-family: var(--xl-font-sans);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  border: 1px solid transparent;
  white-space: nowrap;
  background: var(--xl-color-surface-alt);
  color: var(--xl-color-text-secondary);
  border-color: var(--xl-color-border);
}
.xl-badge__dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor }

.xl-badge--neutral { /* base */ }
.xl-badge--info    { background: rgba(37,99,235,0.08);  color: var(--xl-color-info);    border-color: rgba(37,99,235,0.22) }
.xl-badge--success { background: rgba(5,150,105,0.08);  color: var(--xl-color-success); border-color: rgba(5,150,105,0.22) }
.xl-badge--warning { background: rgba(217,119,6,0.08);  color: var(--xl-color-warning); border-color: rgba(217,119,6,0.22) }
.xl-badge--danger  { background: rgba(220,38,38,0.08);  color: var(--xl-color-danger);  border-color: rgba(220,38,38,0.22) }

[data-xl-theme="dark"] .xl-badge--info    { background: rgba(96,165,250,0.12);  border-color: rgba(96,165,250,0.32) }
[data-xl-theme="dark"] .xl-badge--success { background: rgba(16,185,129,0.12);  border-color: rgba(16,185,129,0.32) }
[data-xl-theme="dark"] .xl-badge--warning { background: rgba(245,158,11,0.12);  border-color: rgba(245,158,11,0.32) }
[data-xl-theme="dark"] .xl-badge--danger  { background: rgba(248,113,113,0.12); border-color: rgba(248,113,113,0.32) }
`;

export default function XLBadge({
  children,
  variant = 'neutral',
  dot = false,
  className = '',
  title,
}) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  return (
    <span
      className={'xl-badge xl-badge--' + variant + ' ' + className}
      title={title}
    >
      {dot && <span className="xl-badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}
